<template>
  <div class="container">
    <div class="d-flex flex-column">
      <div class="d-flex justify-content-start flex-fill">
        <b-nav tabs>
          <b-nav-item :to="{name:'shipBase'}" active>出貨管理</b-nav-item>
          <b-nav-item :to="{name:'shipTrack'}">貨品追蹤</b-nav-item>
        </b-nav>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {

};

</script>